<template lang="pug">
.card-item(:style="item.status===3?op:''"
:class="(isChangeIt === 2||(getAwardGary(item)&& type!==2&&type!==4)||getOver(item)) ? 'op7' : ''")
  .bussiness {{getGoodsPropDesc(item)}}
  .price(v-if="!getAward(item)")
    .num {{getamount(item)}}
    .yuan {{getUnit(item)}}
  .award-block(v-else) {{getamount(item)}}
  .card-word-block(v-if="!getAward(item)") {{getsubWord(item)}}
  .card-status(v-if="getBtnType(item)"
    @click="firstStatus(item,type)")
      div(:style="getFontSize(item.btnName)")
        span {{type?typeMap[type]:getChangeName(item.btnName,item)}}
  .card-change(v-else-if="!isChangeIt" @click="firstStatus(item)")
    span {{getChangeName(item.btnName,item)}}
    .change-img-yellow(v-if="showYellow(item)")
      img(src="https://m.hellobike.com/resource/gallery/61/c16_gZFT_Frame%20(3).png?x-oss-process=image/quality,q_80")
  .card-change-it(v-if="isChangeIt===1" @click="changeIt")
    img(src="https://m.hellobike.com/resource/gallery/61/JfXFAg-c_Vector%20(1).png?x-oss-process=image/quality,q_80")
    span 换掉TA
</template>
<script>
import { env } from '@hb/hbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';

export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
    type: {
      type: Number,
      default: 0,
    },
    couponGameAB: {
      type: String,
      default: 'N',
    },
    isChangeIt: {
      type: Number,
      default: 0,
    },
    isShowAfter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      env,
      op: 'opacity: 0.7;', // 已使用3//未领取的1
      typeMap: {
        1: '已更换',
        2: '变更后',
        3: '已膨胀',
        4: '膨胀后',
      },
    };
  },
  computed: {
    version() {
      if (this.getPropVersion) {
        return this.getPropVersion();
      }
      return '';
    },
  },
  mounted() {
  },
  inject: ['getPropVersion'],
  methods: {
    getBtnType(item) {
      if (this.couponGameAB === 'Y' || this.couponGameAB === 'Z') {
        if (item.status === 11 || item.status === 2 || item.status === 3 || item.status === 9) {
          return true;
        }
        return false;
      }
      if (this.couponGameAB !== 'Y' || this.couponGameAB !== 'Z') {
        return true;
      }
      if (item.changeRecord) {
        if (item.changeRecord.btnName === '已使用') {
          return true;
        }
      }

      if (this.isChangeIt === 2) {
        return true;
      }
      return false;
    },
    getOver(item) {
      if (item.changeRecord) {
        if (item.changeRecord.btnName === '已使用') {
          return true;
        }
      }
      return false;
    },
    getAward(item) {
      if (item.propType === 26) {
        return true;
      }
      if (this.isChangeIt) {
        if (item.status === 9 || item.status === 10) {
          if (item.propType === 26) {
            return true;
          } return false;
        }
      }
      if (item.status === 9 || item.status === 10) {
        if (item.changeRecord && item.changeRecord.propType === 26) {
          return true;
        } return false;
      }
      return false;
    },
    getAwardGary(item) {
      if (item.propType === 26) {
        return true;
      }
      if (item.status === 9 || item.status === 10) {
        if (item.changeRecord && item.changeRecord.propType === 26 && item.changeRecord.status !== 1) {
          return true;
        } return false;
      }
      return false;
    },
    showYellow(item) {
      return (item.afterVipExtendProperty && this.couponGameAB === 'Y') || ((item.afterVipExtendProperty || item.afterVipReplacementProperty) && this.couponGameAB === 'Z');
    },
    getUnit(item) {
      if ((item.status === 9 || item.status === 10) && this.isShowAfter && item.changeRecord) {
        return (item.changeRecord.propType !== 4 && item.changeRecord.propType !== 7) ? item.changeRecord.unit : '次';
      }
      return (item.propType !== 4 && item.propType !== 7) ? item.unit : '次';
    },
    getsubWord(item) {
      if ((item.status === 9 || item.status === 10) && this.isShowAfter && item.changeRecord) {
        return item.changeRecord.subWord;
      }
      return item.subWord;
    },
    getGoodsPropDesc(item) {
      if ((item.status === 9 || item.status === 10) && this.isShowAfter && item.changeRecord) {
        return item.changeRecord.goodsPropDesc;
      }
      return item.goodsPropDesc;
    },
    getamount(item) {
      if ((item.status === 9 || item.status === 10) && this.isShowAfter && item.changeRecord) {
        return item.changeRecord.amount;
      }
      return item.amount;
    },
    getFontSize(value) {
      if (!env.isEasyBikeApp) {
        if (value === '去使用') {
          return 'font-size: 0.11rem';
        }
        return '';
      }
      return '';
    },
    getChangeName(value, item) {
      if (value === '去使用') {
        if (!env.isEasyBikeApp && this.version !== 'ride_universal') {
          this.smallfont = 'font-size: 0.11rem';
          return '去APP使用';
        }
        return value;
      }
      if (item.status === 1) {
        if (item.afterVipExtendProperty) {
          return '膨胀变大';
        }
        return value;
      }
      if ((item.status === 9 || item.status === 10) && !this.isChangeIt && item.changeRecord) {
        if (item.changeRecord.btnName === '去使用') {
          if (!env.isEasyBikeApp) {
            this.smallfont = 'font-size: 0.11rem';
            return '去APP使用';
          }
          return item.changeRecord.btnName;
        }
        return item.changeRecord.btnName;
      }
      return value;
    },

    // eslint-disable-next-line consistent-return
    firstStatus(val, type) {
      if (val.afterVipExtendProperty && this.couponGameAB === 'Y') {
        return this.$emit('openExtend', val);
      }
      if (val.changeRecord) {
        return this.$emit('click-btn', val.changeRecord);
      }
      if (!type) {
        this.$emit('click-btn', val);
      }
    },
    changeIt() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_exchange_coupons_pop',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$emit('changeIt', 1, this.item);
    },
    expansive() {
    },
  },
};
</script>
<style lang="less" scoped>
.op7 {
  opacity: 0.7;
}

.card-item {
  width: 0.77rem;
  height: 0.92rem;
  background-image: url(https://m.hellobike.com/resource/gallery/59/3ShCQVh2_Group%201707483362.png);
  background-size: 100% 100%;

  .bussiness {
    padding-top: 0.03rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 400;
    line-height: 0.12rem;
    text-align: center;
    color: #242729;
  }

  .price {
    margin-top: 0.02rem;
    display: flex;
    justify-content: center;

    .num {
      font-family: "DIN Alternate Bold", sans-serif;
      font-size: 0.26rem;
      font-weight: 700;
      line-height: 0.28rem;
      color: #242729;
    }

    .yuan {
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.11rem;
      font-weight: 500;
      margin-top: 0.1rem;
      text-align: center;
      color: #fa4614;
    }
  }

  .award-block {
    margin: 0.09rem auto 0 auto;
    width: 0.39rem;
    height: 0.39rem;
    background: url('https://m.hellobike.com/resource/helloyun/08345/iBMsO8400i.png');
    background-size: 100% 100%;
    color: #7d3b2a;
    line-height: 0.39rem;
    text-align: center;
  }

  .card-word-block {
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 400;
    line-height: 0.17rem;
    color: #7d3b2a;
    text-align: center;
    overflow: hidden;
    width: 100%;
    opacity: 0.7;
  }

  .card-status {
    margin: 0 auto;
    margin-top: 0.09rem;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 500;
    height: 0.18rem;
    text-align: center;
    color: #7d3b2a;
  }

  .card-change {
    margin: 0.08rem auto 0 auto;
    width: 0.57rem;
    height: 0.2rem;
    border-radius: 0.5rem;
    color: #fff;
    text-align: center;
    line-height: 0.2rem;
    position: relative;
    background: linear-gradient(180deg, #fa4614 0%, #f60 100%);
    font-family: PingFang HK, sans-serif;
    font-size: 0.11rem;
    font-weight: 600;

    .change-img-yellow {
      position: absolute;
      right: -0.06rem;
      top: 0;

      img {
        width: 0.19rem;
        height: 0.2rem;
      }
    }

    .change-img-green {
      position: absolute;
      right: -0.06rem;
      top: 0;

      img {
        width: 0.19rem;
        height: 0.2rem;
      }
    }
  }

  .card-change-it {
    margin: 0.08rem auto 0 auto;
    height: 0.2rem;
    width: 0.57rem;
    border-radius: 0.5rem;
    text-align: center;
    line-height: 0.2rem;
    color: #fff;
    background: #fb990f;
    font-size: 0.11rem;
    display: flex;
    justify-content: center;

    img {
      margin-top: 0.06rem;
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.03rem;
    }
  }
}
</style>
